import LayoutDefault from "@/layouts/LayoutDefault";

export default LayoutDefault;
